// Final whole-application English and Filipino UI catalog.
export const finalEn = {
  "002bdbfcf96d": "Parts Used",
  "002c6fe8026a": "Labor Cost",
  "00d4dbbb759a": "Electrician, Mason, Plumber…",
  "0105252023c5": "Unit Cost",
  "018fa09eb9c5": "Total paid:",
  "01dbf9f814b1": "Driver / Delivery Person",
  "032e57accfe1": "Amount (₱)*",
  "03a8b8a27e2a": "Price/Liter",
  "04086c201fe3": "Active Plots",
  "042c862e4467": "Try again",
  "0442e09452f3": "Set one now",
  "044745750a25": "Jayson Diaz Hernandez",
  "046e5cee819c": "In Transit",
  "04b7b26c8ca2": "Critical",
  "04dc2a4dbf34": "Fuel this month:",
  "050b3822ca19": "Species Performance",
  "05375be4bc00": "Log a status note and progress %.",
  "05882967d7f8": "Present Today",
  "060be00f4f26": "All categories",
  "0696fec6fead": "Fits Equipment (optional)",
  "07217c77199f": "Overdue",
  "084fe2b79161": "Operator:",
  "08b99c5d3e8f": "New Asset",
  "08cc443744dc": "Received Date",
  "099260f0b716": "Complete fleet operations for vehicles, tractors, motorcycles, ATVs, trucks, trailers, boats, and heavy/custom equipment.",
  "09a36db7c9f2": "Stocked",
  "09fef5d8d9a3": "Failed",
  "0a82c3251c51": "Supplier Snapshot",
  "0aa8ae04295f": "Loc:",
  "0b645d1b6599": "Fuel",
  "0bdb018de927": "Progress Updates (",
  "0bf662f2c2f6": "Log Harvest",
  "0c1e1d66e049": "Unreceived value",
  "0c6c4102d4df": "Optional",
  "0ccd6397bea6": "Task completion:",
  "0d7c240cba1c": "Inspections",
  "0da1cb3c480b": "Insufficient data",
  "0da45a691d78": "Progress %",
  "0dff09425a20": "Delivered Today",
  "0e48c7de4a3f": "kg, L, bag…",
  "0e85749a6f40": "Customer",
  "0e8a3ad980ec": "target",
  "0efc2e6be4c2": "Overview",
  "0f0264a43f32": "Photo (max 5 MB — auto-compressed)",
  "0f0ce6d6e190": "Registration Due:",
  "0f5d65298aa8": "Today's Attendance",
  "0fde937b9081": "Crop Management",
  "102a5880ded7": "Budget:",
  "10478ff84412": "Sales (Month)",
  "108839a6a9c6": "Expected harvest",
  "10fcd25bf442": "Expenses (",
  "1131d8224bf0": "· in",
  "117b44ac2067": "Monthly Fuel Cost",
  "126dd3b70a5c": "Logs",
  "12cf8c715664": "Track a specific field or growing area. Click the map to drop a GPS pin.",
  "13537cab231b": "Daily and weekly checklists live in",
  "142b5758f344": "Wind",
  "145caf292855": "Due",
  "149183406751": "Log Maintenance",
  "149c06e3f613": "No expenses yet.",
  "15d42f2900c2": "L @",
  "161e50dbc720": "Ranges tuned for Tilapia, Bangus and other Philippine warm-water species. Readings outside these ranges get flagged in orange (warn) or red (critical, > 20% outside).",
  "166240377046": "Service Overdue",
  "16f70fd60f05": "Colour coded live: green = healthy, amber = warning, red = critical.",
  "1706df6036ce": "Equipment Inspection Templates",
  "17087666e54c": "Add Update",
  "170c36264a9c": "Record inputs, labor and field operations. Cost flows into P&L.",
  "1798b3ba42ee": "Completed",
  "17d809d2e31a": "Seed source",
  "18dc84705bac": "Search name, location, notes…",
  "18faa35def10": "No engine-hour logs yet.",
  "19ad699baa33": "Scheduled Date",
  "19b818028820": "Crop*",
  "19f4a18f9f8b": "Budget (₱)",
  "1a2309aff4b1": "Purchase Cost (₱)",
  "1a3c52bfd713": "Maintenance Schedule",
  "1a56b9e8f6db": "Edit plot",
  "1b90271d66cf": "Progress",
  "1bd2d1a15a43": "Purchase History",
  "1c5855ed9335": "Service Schedule",
  "1c670bf34c19": "· Reorder at",
  "1c8c444ef1fc": "Fuel Logs",
  "1cd1bdad468f": "Scheduled",
  "1d661af9ea42": "No contractors yet.",
  "1de07a26ff24": "Mileage/Odometer",
  "1e02127a4af1": "Total Plots",
  "1e49abec1181": "Add a pond, tank or cage with stocking info.",
  "1e5ff9e500c2": "Qty",
  "1ea7ee5d6e95": "Purchase Orders",
  "1ef085c054e7": "Parts:",
  "1efd3e280145": "Aquaculture",
  "1f77e83907c4": "Choose...",
  "1fd266c217d7": "All Categories",
  "1fd2b5b554e8": "More pages",
  "1fd6a805dae7": "Registry",
  "20e338624cee": "Assets",
  "2144d9aeea32": "Engine Hours — Last 30 Days",
  "231ce14decd0": "No harvests logged.",
  "2376a0d7507c": "Photos:",
  "23865ea0f0a2": "Add Equipment",
  "24a46c6bc0d7": "Build. Maintain. Track.",
  "24f02ec6aa87": "Log Service / Repair",
  "24f53d5101fb": "No updates yet.",
  "25351761708f": "Total order value",
  "255640665eb7": "Under Repair",
  "2637a450046c": "Inventory Item *",
  "27548c4fc95d": "Received",
  "276652d8d16b": "Recent Engine Hour Logs",
  "27d5482eebd0": "h",
  "292f708ce44c": "Enter your account email. If it is eligible, we’ll send a secure reset link.",
  "2942e6ae9dc3": "Engine Hours",
  "29706cca17e6": "Open orders",
  "2a8aef209cf4": "External worker, supplier, or specialist.",
  "2b4ed7018503": "Hours at Service",
  "2b7b55a616a9": "Create a draft purchase order to capture a request.",
  "2b936fc87d66": "Insufficient chart data.",
  "2bb6b986c5d6": "active",
  "2c924e308820": "Note",
  "2c96b3659b1c": "Loading overview...",
  "2d2a1342f45d": "Next Service Date",
  "2d3141877a3e": "Spare Parts",
  "2dd2bed72567": "today",
  "2dd799d5d755": "View POD",
  "2efa7067399a": "active projects",
  "2f4979324e03": "Condition",
  "2f8f376ad77b": "Receiving",
  "309c693a5ffa": "Customer name",
  "30ad4167acea": "Remaining:",
  "3142b38e900f": "Fleet Expenses",
  "31e1ca3152df": "Buildings & Infrastructure",
  "31fbb9d2e0d1": "pagination",
  "32cf4b682e2b": "Executive View",
  "33ce417454bf": "Loading…",
  "33f0b19c138a": "· Variable/unit",
  "3430e769856a": "· Labor",
  "346b137aaeb4": "Overdue Service",
  "34a79d015463": "Yield (kg)",
  "34be468c005c": "In Use",
  "355bcc577d71": "Finished",
  "35683fd19bd3": "No purchase orders",
  "35aafb9af03e": "Search lot, product, or supplier...",
  "35cf82f9d2a9": "Revenue",
  "36155d48f460": "Equipment",
  "36d4b773518b": "Plot",
  "3703cd216881": "Health",
  "373a53a12353": "Contractors",
  "38eb50e0cbea": "AND A BETTER FUTURE.",
  "38ef04880312": "Cannot change farm records",
  "38ff36471160": "Well, river, rain…",
  "3917cc63a2b1": "Fuel Type",
  "396c65e60e58": "Supplier *",
  "3a670a7af036": "No ponds yet.",
  "3b158d60607f": "Add to Home Screen — works offline in the field.",
  "3b4dfc971393": "Working",
  "3b906ae77c48": "— None —",
  "3c1a07ad42ed": "e.g. LOT-2026-001",
  "3c363836cf4e": "d",
  "3c45b957fdc8": "Purchase Order",
  "3ca8f5487b17": "vehicles",
  "3d0ec3f6c93a": "Supplier Analytics",
  "3d5553209809": "Today ·",
  "3dd7d56a8ed3": "Export PDF",
  "3deb74565196": "Type",
  "3f0631d97412": "Area (hectares)",
  "3f657f29e683": "Choose a new password",
  "4011820e918a": "e.g. Urea 46-0-0",
  "404c5194e7ac": "Target harvest",
  "4052cedd127f": "Supplier count",
  "40cd63f2ed77": "Photo Gallery URLs (one per line)",
  "412226715c56": "Clear filters",
  "4130f658233f": "Add Unit",
  "416a07cf4e79": "Description*",
  "4186c93a90f9": "Buyer",
  "41fbe295b7ab": "Stage:",
  "4310ed540c1c": "Late",
  "4317a9f49f13": "On Break",
  "43365110276c": "Rain now",
  "439e231109dc": "Order Date",
  "43dc8532f7e5": "Amount",
  "4496cd8c9d41": "Choose plot…",
  "44d25b5d1b6d": "Items",
  "44f6af694554": "Quantity",
  "4629710df161": "Active employees",
  "465aedef3c60": "Loading forecast…",
  "4729f4827a28": "Log Engine Hours",
  "4755bb542fc4": "No spare parts yet.",
  "48bc81639dbc": "Ponds",
  "48fe35a1d256": "Sales · Profit · Break-Even · Targets · Payroll ·",
  "4949c4c8f45c": "Total Value",
  "499bd9281e33": "Monthly Payroll",
  "4a245944efb6": "Export Excel",
  "4a3c315b5cb3": "Water Quality Logs",
  "4a7c565d4c44": "Confirm password",
  "4b8e53dd3dae": "No monthly target set.",
  "4bab2d8fe13f": "More",
  "4bcd00d023b4": "Notes / Work performed",
  "4be4414aa252": "Total Ponds",
  "4bf41b254218": "No receiving queue",
  "4c10f68d1ec6": "project(s) are",
  "4c25b4dd9300": "Track pond stocks and water-quality metrics (Tilapia · Bangus · Catfish · Shrimp).",
  "4c98c7c959cf": "Read-only decision support",
  "4cb8d8545ed6": "Station",
  "4d4add04f200": "Comma-separated parts",
  "4da821676b2f": "Back to sign in",
  "4dcd818cab26": "Supplier Directory",
  "4e4a56efd2f0": "Maintenance Cost",
  "4edef537bfac": "Odo:",
  "4efaca55bbdd": "No service records yet.",
  "4f3a4ea5fc7f": "hrs ·",
  "4f68eeac77e4": "Projects, assets, contractors, budgets and repair schedules — all in one place.",
  "501e80194351": "Revenue (₱)",
  "5057c9400b5c": "Health guidance is decision support only, not a veterinary diagnosis. Serious, worsening, or uncertain cases require veterinarian review.",
  "50b61e0c8341": "Expiring Soon",
  "50f94286ba30": "Previous",
  "51f98f12a890": "Service Interval (days)",
  "524d1b0e5963": "Receipt reference",
  "527d428ee46b": "Assigned Driver",
  "52b139c9d30c": "Amount (",
  "5301648dcf6b": "Edit",
  "535f9fd79916": "e.g. Deliver before 10 AM",
  "53a849c428ba": "Hours Alerts",
  "53e890d5f0ff": "Projects",
  "55edd462872a": "Supplier",
  "55ef43bbccd7": "· Hours",
  "55f8ebc805e6": "Description",
  "5612a12912ba": "Repair · Month",
  "5635a7fdb9c2": "d (",
  "56e3badc4e6c": "Refresh",
  "57162c35dea4": "Name*",
  "57328afd89ad": "Assign a customer, driver, and scheduled date.",
  "57a923cebb64": "Payment Tracking Snapshot",
  "57d6453a76e4": "This reset link is invalid. Request a new one.",
  "582c2c765413": "Plot name*",
  "58caebadd832": "Planted",
  "59ef31e37acc": "Reorder Level",
  "5a2a2aa092fe": "No fleet expenses yet.",
  "5a32ec8d373c": "Outstanding value",
  "5a61e634ec49": "PLAN",
  "5af2ae528662": "Log Activity",
  "5b62ea1bf903": "Ponds & Water Quality",
  "5bcce6c9362d": "Total Vehicles",
  "5bdc5634400e": "Receipt Upload",
  "5c0a29f837f1": "Hours:",
  "5c7f68126c6b": "21 default categories + your custom ones. Owner can add unlimited custom categories.",
  "5c9c59bd74d3": "Delete plot",
  "5d08f9511d95": "Rows:",
  "5d597153857a": "Track a construction, expansion, or repair job with budget and progress.",
  "5e7c42bc25c3": "AI Katulong",
  "5e7dbabf8c70": "GROW",
  "5ee99df097d2": "Rating (1-5)",
  "5f60b1c2e605": "Repair",
  "5f8b47c8c9a9": "-day forecast",
  "6036f38949f0": "Health Score",
  "610c693d18b1": "Expenses (Month)",
  "616ec7943070": "Loading purchasing...",
  "6197c35f640d": "Log Fuel",
  "61b1942702f8": "Add your first plot",
  "61cc55aa0453": "Add",
  "61d2e70b54c2": "Traceability",
  "62a0ddfe7104": "Oil Change Due:",
  "62b4e20b30bd": "Yield (kg)*",
  "63a33115983f": "Ask about authorized farm records…",
  "64ae43e8fe76": "Cost",
  "64f5d600a1cc": "Pond",
  "65004e4ff3fd": "overdue service",
  "6553548c02a1": "Received orders will appear here.",
  "65adb9c296d2": "Humidity",
  "65c2337e5a7b": "Assigned Operators",
  "65f495119086": "to start.",
  "6723e47bb201": "reorder @",
  "674d8f64aa0b": "Battery Replacement:",
  "67f0a1936718": "Reading (hours)",
  "6923181702d9": "Spent:",
  "69a52c6de668": "Next:",
  "69bd4ef9fbd0": "View",
  "6b12d06ba166": "Operating",
  "6c19a4761d7e": "Listening…",
  "6ca74ddd7700": "low)",
  "6ccb60071be8": "Categories",
  "6d304f7b0a2f": "6-Month Trend",
  "6da13addb000": "Source",
  "6e0f112a6c87": ". Fill and score them there.",
  "6e3d52434a58": "Purchasing",
  "6e5ce570b4af": "breadcrumb",
  "6e9397b6dbba": "Monthly Sales Target",
  "6e979f426b67": "MB",
  "6eef6648406c": "None",
  "6f4789b025a1": "Open →",
  "6f6f0f6a0fb3": "m²",
  "6f9f011c5d36": "Longitude",
  "6fceba68eac8": "Purchase Requests",
  "701c3a2750eb": "Log harvest",
  "70440046a3dc": "Notes",
  "704aac3a9bc5": "Supplier records appear automatically from live inventory items and purchase orders.",
  "709a23220f2c": "Name",
  "70f132fe13e6": "fields",
  "70f90c2aa98d": "Barangay or landmark",
  "71e7e5db4ac7": "Next Due Date",
  "747876156da0": "Purchase Cost",
  "74feb2cafbea": "Purchase Date",
  "750134b65d1b": "Total Expenses",
  "753a22b2eb61": "Notifications",
  "7564829fea86": "No batches match. Add your first!",
  "7600ac5e38ed": "Service Due:",
  "7658feb298a0": "Assigned Operator",
  "76cadcf0cd78": "Farm records are summarized and minimized before provider use.",
  "77064d526523": "Phone",
  "77777ca55ede": "No equipment yet. Click",
  "7790f856aec6": "No purchase history",
  "77dfd2135f4d": "Cancel",
  "788e8718ca16": "Contractor (optional)",
  "7a2c34cb789c": "Logistics",
  "7a4af421292d": "New Plot",
  "7ab3015465a9": "Search orders",
  "7aeba4cd15b1": "Budget",
  "7c62a1424469": "Available",
  "7ceee3f3615a": "Provider",
  "7d8f801f3a78": "· Contractor:",
  "7da62f0b3f3f": "Assign later",
  "7e3275fc04cc": "Loading product batches…",
  "7e4edd862a9d": "Harvest ETA",
  "7e5897fc1324": "Ask for grounded farm decision support",
  "7f3cc23a2ff3": "Received by (name)",
  "7ffef0952c80": "Next svc:",
  "80ea156e1b83": "Healthy",
  "81259aa4c0b6": "Filter, Belt, Bearing…",
  "81928ede6ce6": "Offline — using cached data",
  "81b7d2ea42df": "Date:",
  "83760b6974e1": "Add Part",
  "83e2cb2108d1": "No fuel logs yet.",
  "842b7b5d7189": "Dates",
  "8430451c6c61": "Pick product",
  "84add5b29527": "Email",
  "84d296628caf": "Expected Date",
  "8544a4772583": "Profit",
  "85684fd76214": "employees marked today",
  "86761b63a7bd": "records",
  "869bd1fe0a00": "Low Stock Items",
  "877d5d5fa796": "Outstanding Orders",
  "88bc3fe3dadd": "Reports",
  "89c4cc389c22": "Purchase orders created here will appear live.",
  "8a2783493a54": "Upcoming Services",
  "8b8b0e4621e0": "Farm:",
  "8bf1ef5668b1": "Batch",
  "8c603960eb2f": "No species yet.",
  "8d007050838a": "Expiry Date",
  "8d437dbf95ab": "Expenses",
  "8d993b6d8820": "Go to previous page",
  "8dce170de238": "Value",
  "8e53512a50fa": "Previous slide",
  "8e9f1d6e54b9": "Not Started",
  "8eadc26886a5": "Active Projects",
  "8f7de73e0745": "Forms & Assessments",
  "8faf93a978fd": "CAPEX (Month)",
  "8fba6b663578": "Next Service",
  "8fe9db16be51": "Area:",
  "90c4ecded385": "Lot Number *",
  "910dc60963c7": "upcoming ·",
  "91262062ba6b": "Log Water Quality",
  "917625318331": "units",
  "91cae9bcc20c": "Plate:",
  "92210c2cbd8f": "Supplier directory, purchase requests, purchase orders, receiving, purchase history, outstanding orders, and supplier analytics.",
  "9338d7d6f677": "FOR A STRONGER FARM",
  "936c86894f66": "Install AJ's Farm",
  "937c13e9e29c": "Qty Received *",
  "948bdc50fc2a": "Harvests",
  "9497c416e33c": "Log Service",
  "94c0384715e4": "· Fixed",
  "94db78855af5": "Clear pin",
  "94de303bbef8": "Maintenance",
  "952f375412e8": "Start",
  "9631af52c66f": "Delivery",
  "965fb2ddf63d": "Receive",
  "96662245e860": "Receipt URL",
  "96bb1ede828d": "POD",
  "97ca5f493a3d": "Draft, requested, approved, and ordered records are treated as live purchase requests using the existing purchase order backend.",
  "98061c6fa8e2": "Unit Cost (₱)",
  "9a14702e37fb": "No plots yet.",
  "9b761dd12960": "Log crop activity",
  "9b8dfdff736c": "BUILD",
  "9bb28c0dd307": "Vehicle",
  "9bd9a1fc0241": "Orders that still need receiving will appear here.",
  "9c0048f2d882": "Log Hours",
  "9c3befe7e22c": "Notes:",
  "9c7f732592c6": "Plots",
  "9cb29e734a6c": "All Statuses",
  "9cbf868b72bc": "Total Budget",
  "9d579ae4103f": "No projects yet. Create your first project to start tracking.",
  "9d7ab1a55796": "Start Date",
  "9d94dbbd57c9": "Suppliers are derived from inventory items and purchase orders.",
  "9daa9201229d": "Cost/Unit",
  "9f5cd8a2e880": "Retry",
  "a124947cbd2d": "Low",
  "a17866573e05": "°C",
  "a225c8ebcac0": "Storage Location",
  "a229be11aa83": "e.g. Tool Shed, Barn A",
  "a278a03b221f": "— Shared pool —",
  "a2798d52947c": "Answers cite the AJ's Farm data categories used. Verify important operational, financial, and animal-health decisions with the responsible person.",
  "a2876d155984": "Primary Contractor",
  "a28f0cb43bd1": "Full delivery address",
  "a2a8b6d44e29": "Size (m²)",
  "a2f060b7363f": "Forgot your password?",
  "a371e0e8950b": "Requests in pipeline",
  "a38fbb777345": "No engine hour logs yet — add one to see trend.",
  "a3c686e711e4": "Category",
  "a4cf971af7dc": "Next slide",
  "a4ec6579de8a": "Upcoming (date-based)",
  "a4f83557c6d5": "Plot*",
  "a52f821adb26": "Lot numbers, expiry dates, remaining quantity, and supplier per batch.",
  "a5905ef77ee7": "Use a safe example question",
  "a5b943a2e873": "Pond A",
  "a689a999a5e6": "Expired",
  "a69606c0dc7b": "Location label",
  "a733b809d2f1": "Active",
  "a73c0b6b0574": "Account recovery",
  "a77a70c1dafa": "PLAN • BUILD • GROW",
  "a98926213d84": "Specialty",
  "a994e25516c0": "No report rows.",
  "aa9b6a90f790": "Progress Update",
  "ab478f3efc84": "Map",
  "ab6e3f083b35": "· Next",
  "ac154da76d74": "over budget",
  "ac2dfb38024b": "Received orders",
  "ad166ddcd6ce": "New Contractor",
  "ae61226fd3ab": "Input / Product",
  "ae65324b857d": "Farm Operations",
  "aecc49c15355": "Grade",
  "aef614ca416f": "Invoice (optional)",
  "afdec0018746": "Track plots, activities, inputs and harvest yields.",
  "b077b9af222e": "Planted:",
  "b0854dcfffc4": "₱/kg",
  "b0946c471bef": "Select item",
  "b13bdb89caf8": "Cost (₱)",
  "b1951f9838fc": "Fleet Expense",
  "b1da58baf669": "Healthy Ranges",
  "b218a79feffb": "Add your first pond",
  "b25928c69902": "Total",
  "b3d95022b903": "Buildings, farm infrastructure, or other non-vehicle/non-machinery assets. (Vehicles → Fleet · Machinery/tools/pumps/generators → Machinery & Equipment.)",
  "b42abd2e5039": "Fuel Log",
  "b452abc00d55": "Low Stock Alerts",
  "b568d47f2e24": "Input",
  "b5b7f6b7f66a": "Driver:",
  "b5d8da40f3ed": "Total Cost",
  "b6531fded9a0": "Latest reading ·",
  "b6745abedefa": "AI Assistant is not available",
  "b69f996cc7ab": "· via Open-Meteo",
  "b766753f6fa4": "Dismiss install prompt",
  "b7873d633d9b": "Any handover details",
  "b8f5ffa03eb9": "e.g. Coffee Pulper",
  "b9e04d3e4d00": "Back online — reconnecting",
  "ba2fff4051e9": "overdue",
  "ba8f571e0f93": "Expiry",
  "bacca935870a": "Could not load Purchasing",
  "bae7d5be7082": "Status",
  "bb56811cbaa0": "Fuel, registration, insurance, repairs, parts, tires, battery, oil, labor, and other operating costs.",
  "bbc7f274b22b": "No activities logged.",
  "bbfa773e5a63": "Close",
  "bc4f986ecbca": "Deliveries",
  "bc981983e7f5": "Next",
  "bca6293c399c": "Mark Received",
  "bcc80a05869a": "Income (Month)",
  "bd55c18395bf": "Search by ID, plate, VIN, barcode...",
  "be3e12ed5902": "Qty Remaining",
  "be90668bac63": "New Batch",
  "befd12a53600": "Target Date",
  "c010b1f6ac90": "plots have GPS coordinates. Set a plot's location by editing it and clicking on the map inside the dialog.",
  "c044647b0197": "- Unassigned -",
  "c088d79f1373": "Service Upcoming",
  "c0d3c936adcd": "Spent",
  "c22d763a0516": "Total Batches",
  "c3290bda1143": "Equipment Categories",
  "c3ab24576f62": "— Unassigned —",
  "c3b69e661eec": "Choose…",
  "c4ebb2c814de": "asset(s) have",
  "c59c94e09696": "New Order",
  "c5db3d91c4cb": "Crop",
  "c628afb091a6": "Maintenance · Month",
  "c83f9e9d5b4d": "No fleet units match the current filters.",
  "c98cdd2ee123": "No purchase requests",
  "c9b5eabe92c4": "Service History",
  "c9f9a9698524": "Next Due @ Hours",
  "ca6d0e3aaa7d": "Stage",
  "cac7bbb6b67b": "Jane Doe",
  "cb0538e4ad77": "· overdue",
  "cb9e0f796b49": "Backend-calculated from live costs. Avg sale price",
  "cbce6e1d7dcf": "Fuel:",
  "cc1ebdd04e76": "Idle",
  "cc632b5e2fd2": "Remaining",
  "cccb682b71cf": "Save Reading",
  "cce4cc8c49b7": "Product Batches",
  "ccf67dadebe3": "Total Spent",
  "cd368978369a": "In Repair",
  "cd624d178121": "Upcoming & Overdue Service",
  "ce99976c1fee": "Feels",
  "cec5fc32e25c": "Hours-based Alerts",
  "ced3905ec822": "Latitude",
  "cefb1df1fe3d": "No upcoming maintenance in the next 14 days.",
  "cf86f160deef": "AJ'S FARM MANAGEMENT SYSTEM",
  "cfb5a2036e18": "Reviewing authorized farm summaries…",
  "cfe7f49e435d": "Schedule Delivery",
  "d1a17af19f53": "Not available",
  "d219c68101f5": "Location",
  "d2b8fb209caf": "Walk-in / Manual",
  "d2e9fc569cf0": "Machinery & Equipment",
  "d4acbd528026": "Crops & Fields",
  "d5cf913dc0e0": "Capture buyer signature/name and a photo of the handover. Photo auto-uploads to your Google Drive Photos folder.",
  "d64f648a7f85": "Save Purchase Order",
  "d6941bad8202": "No deliveries yet. Schedule your first!",
  "d6fa7b9a44a6": "e.g. Manong Reyes",
  "d6fdbd2508cb": "Expiring <7d",
  "d70f93df5e8f": "Address",
  "d850ee188c7c": "New password",
  "d87f47b47e4d": "Dashboard",
  "d8d4986afb9d": "Seed variety",
  "d8e7170f94e7": "Total:",
  "d8f09bb951ba": "Tyre Replacement:",
  "da2be8a737a6": "Expected Harvest",
  "da33e1b7e0c4": "Construction",
  "da7be9accee6": "· reading",
  "daa495690e5b": "Warranty Expiry",
  "dbb3ca9ccf55": "Equipment Name / ID",
  "dbc0dcff747b": "Add a line-item cost against this project.",
  "dc3b2aa7a0e8": "No outstanding orders",
  "dc6a02db7a5b": "Stocked Count",
  "dd3b86d1ef21": "Product",
  "dd44e0c7f248": "Auto-filled after upload",
  "dd8dbbd79e86": "Part Number",
  "ddab284f43b2": "Proof of Delivery ·",
  "de04fa0e29f9": "of",
  "de4fc5601204": "Construction & Maintenance",
  "de7b27e508f3": "AJ'S FARM",
  "de8dc3b5d39f": "Area (ha)",
  "e262a962cde2": "Record yield and revenue.",
  "e2767823d537": "North Field A",
  "e3970bebf8df": "No supplier records",
  "e40e6e6c4312": "Stocked count",
  "e45eb77d9c06": "Product *",
  "e51c55255be9": "Records",
  "e52a04d0c8ce": "Water source",
  "e58f7f889902": "Activities",
  "e623de0e43ee": "e.g. Rice (Palay)",
  "e6469a65672a": "ALL IN ONE COMMAND CENTER",
  "e7048b02e423": "Paid / received value",
  "e7278d717608": "Stocked date",
  "e7eccafdec41": "Liters",
  "e8171eb8b82a": "Break-Even Snapshot",
  "e8d05704af77": "Lot #",
  "e8f88ca7278e": "Total Equipment",
  "e95921ab1183": "Fleet Inspection Templates",
  "e9b450d14bc2": "Done",
  "e9c45563358e": "Warning",
  "ea1787935b0b": "Secure reset",
  "ea3c24ad2473": "Utilization",
  "eb744bda0628": "No Expiry",
  "eb9a4bc1c0c1": "Date",
  "ec37183a6f52": "Save Batch",
  "ecc3fb27c580": "Healthy Water-Quality Ranges (Warm-water Fish)",
  "eefa183380c8": "· Odo",
  "eefc13716b45": "One or more readings are critically outside healthy range. Consider immediate remediation (water change, aeration, etc.).",
  "ef46a8d2a13d": "GPS location — click on the map to drop a pin.",
  "efac482c1b4d": "Pond*",
  "efc007a393f6": "Save",
  "f01f5d7ee661": "No water-quality logs yet.",
  "f0f704fd3636": "Use at least 12 characters with upper-case, lower-case, and a number.",
  "f12d9541e2f3": "e.g. Pig Pen 3",
  "f16f60e54c46": "New Pond",
  "f187d5a1cc2f": "— Uncategorized —",
  "f1bf035da178": "Record a purchased or produced lot for traceability.",
  "f4286ad9a793": "Fuel Consumption & Cost",
  "f4d631a14799": "VIN:",
  "f53d122b2016": "Add Expense",
  "f5d794b98db8": "Schedule, dispatch, and confirm every farm delivery with photo POD.",
  "f64a2d812f7d": "Created today for the generations of tomorrow.",
  "f65d3258c00d": "Fresh",
  "f6741ee79071": "Maintenance / Repair",
  "f6b935ab3371": "Unit",
  "f6ce3b6fcfca": "Receipt",
  "f700fcdb40d3": "Insurance Due:",
  "f729524fe595": "Outstanding purchase orders are your receiving queue.",
  "f7d8733d94d5": "Supplier, note, date, status...",
  "f8ee57ec8645": "Outstanding",
  "f9316ab14683": "Fleet Management",
  "f9543f047f25": "Open in Forms",
  "f967a88e008c": "No suppliers yet",
  "f9c30b15af01": "Break-Even Units",
  "f9eb0ad15ac8": "Fine-tune →",
  "f9fc27b9374a": "ha",
  "fa16fa0d667b": "Species*",
  "fb06270f7c21": "Page",
  "fd25edf497e5": "Harvest:",
  "fd57e65b2e31": "New Project",
  "fd6c3ebf7bef": "Install",
  "fd7164f9ddd6": "Go to next page",
  "fdd37fc793a8": "Order Value",
  "fe88fffd8a1e": "e.g. IR64",
  "fea8990fd0a9": "Overdue ·",
  "feb2bbaaed5b": "Missing:",
  "ff005838422b": "unmarked",
  "ff5b93665a3a": "Cost / Unit ("
};

export const finalTl = {
  "002bdbfcf96d": "Parts Used",
  "002c6fe8026a": "Labor Gastos",
  "00d4dbbb759a": "Electrician, Mason, Plumber…",
  "0105252023c5": "Unit Gastos",
  "018fa09eb9c5": "Kabuuan paid:",
  "01dbf9f814b1": "Driver / Delivery Person",
  "032e57accfe1": "Halaga (₱)*",
  "03a8b8a27e2a": "Price/Liter",
  "04086c201fe3": "Mga Aktibong Plot",
  "042c862e4467": "Try again",
  "0442e09452f3": "Set one now",
  "044745750a25": "Jayson Diaz Hernandez",
  "046e5cee819c": "In Transit",
  "04b7b26c8ca2": "Kritikal",
  "04dc2a4dbf34": "Fuel this month:",
  "050b3822ca19": "Species Performance",
  "05375be4bc00": "Log a status note and progress %.",
  "05882967d7f8": "Present Ngayon",
  "060be00f4f26": "Lahat ng categories",
  "0696fec6fead": "Fits Kagamitan (optional)",
  "07217c77199f": "Lampas sa Takdang Petsa",
  "084fe2b79161": "Operator:",
  "08b99c5d3e8f": "Bagong Asset",
  "08cc443744dc": "Natanggap Petsa",
  "099260f0b716": "Complete fleet operations for vehicles, tractors, motorcycles, ATVs, trucks, trailers, boats, and heavy/custom equipment.",
  "09a36db7c9f2": "Stocked",
  "09fef5d8d9a3": "Failed",
  "0a82c3251c51": "Supplier Snapshot",
  "0aa8ae04295f": "Loc:",
  "0b645d1b6599": "Fuel",
  "0bdb018de927": "Progreso Updates (",
  "0bf662f2c2f6": "Itala ang Ani",
  "0c1e1d66e049": "Unreceived value",
  "0c6c4102d4df": "Opsyonal",
  "0ccd6397bea6": "Task completion:",
  "0d7c240cba1c": "Inspections",
  "0da1cb3c480b": "Insufficient data",
  "0da45a691d78": "Progreso %",
  "0dff09425a20": "Delivered Ngayon",
  "0e48c7de4a3f": "kg, L, bag…",
  "0e85749a6f40": "Customer",
  "0e8a3ad980ec": "target",
  "0efc2e6be4c2": "Pangkalahatang-ideya",
  "0f0264a43f32": "Photo (max 5 MB — auto-compressed)",
  "0f0ce6d6e190": "Registration Due:",
  "0f5d65298aa8": "Ngayon's Attendance",
  "0fde937b9081": "Pamamahala ng Pananim",
  "102a5880ded7": "Badyet:",
  "10478ff84412": "Sales (Month)",
  "108839a6a9c6": "Expected harvest",
  "10fcd25bf442": "Expenses (",
  "1131d8224bf0": "· in",
  "117b44ac2067": "Monthly Fuel Gastos",
  "126dd3b70a5c": "Logs",
  "12cf8c715664": "Track a specific field or growing area. Click the map to drop a GPS pin.",
  "13537cab231b": "Daily and weekly checklists live in",
  "142b5758f344": "Wind",
  "145caf292855": "Due",
  "149183406751": "Itala ang Maintenance",
  "149c06e3f613": "Walang expenses yet.",
  "15d42f2900c2": "L @",
  "161e50dbc720": "Ranges tuned for Tilapia, Bangus and other Philippine warm-water species. Readings outside these ranges get flagged in orange (warn) or red (critical, > 20% outside).",
  "166240377046": "Service Lampas sa Takdang Petsa",
  "16f70fd60f05": "Colour coded live: green = healthy, amber = warning, red = critical.",
  "1706df6036ce": "Mga Template ng Inspeksyon ng Kagamitan",
  "17087666e54c": "Magdagdag ng Update",
  "170c36264a9c": "Record inputs, labor and field operations. Gastos flows into P&L.",
  "1798b3ba42ee": "Nakumpleto",
  "17d809d2e31a": "Seed source",
  "18dc84705bac": "Maghanap name, location, notes…",
  "18faa35def10": "Walang engine-hour logs yet.",
  "19ad699baa33": "Naka-iskedyul Petsa",
  "19b818028820": "Crop*",
  "19f4a18f9f8b": "Badyet (₱)",
  "1a2309aff4b1": "Pagbili Gastos (₱)",
  "1a3c52bfd713": "Maintenance Schedule",
  "1a56b9e8f6db": "I-edit plot",
  "1b90271d66cf": "Progreso",
  "1bd2d1a15a43": "Kasaysayan ng Pagbili",
  "1c5855ed9335": "Service Schedule",
  "1c670bf34c19": "· Reorder at",
  "1c8c444ef1fc": "Fuel Logs",
  "1cd1bdad468f": "Naka-iskedyul",
  "1d661af9ea42": "Walang contractors yet.",
  "1de07a26ff24": "Mileage/Odometer",
  "1e02127a4af1": "Kabuuan Mga Plot",
  "1e49abec1181": "Magdagdag ng a pond, tank or cage with stocking info.",
  "1e5ff9e500c2": "Qty",
  "1ea7ee5d6e95": "Mga Purchase Order",
  "1ef085c054e7": "Parts:",
  "1efd3e280145": "Aquaculture",
  "1f77e83907c4": "Pumili...",
  "1fd266c217d7": "Lahat ng Kategorya",
  "1fd2b5b554e8": "More pages",
  "1fd6a805dae7": "Registry",
  "20e338624cee": "Assets",
  "2144d9aeea32": "Engine Hours — Last 30 Days",
  "231ce14decd0": "Walang harvests logged.",
  "2376a0d7507c": "Photos:",
  "23865ea0f0a2": "Magdagdag ng Kagamitan",
  "24a46c6bc0d7": "Build. Maintain. Track.",
  "24f02ec6aa87": "Itala ang Service / Repair",
  "24f53d5101fb": "Walang updates yet.",
  "25351761708f": "Kabuuan order value",
  "255640665eb7": "Under Repair",
  "2637a450046c": "Inventory Item *",
  "27548c4fc95d": "Natanggap",
  "276652d8d16b": "Recent Engine Hour Logs",
  "27d5482eebd0": "h",
  "292f708ce44c": "Ilagay ang email ng iyong account. Kung kwalipikado, magpapadala kami ng secure na reset link.",
  "2942e6ae9dc3": "Engine Hours",
  "29706cca17e6": "Open orders",
  "2a8aef209cf4": "External worker, supplier, or specialist.",
  "2b4ed7018503": "Hours at Service",
  "2b7b55a616a9": "Create a draft purchase order to capture a request.",
  "2b936fc87d66": "Insufficient chart data.",
  "2bb6b986c5d6": "active",
  "2c924e308820": "Note",
  "2c96b3659b1c": "Naglo-load ang pangkalahatang-ideya...",
  "2d2a1342f45d": "Next Service Petsa",
  "2d3141877a3e": "Spare Parts",
  "2dd2bed72567": "today",
  "2dd799d5d755": "View POD",
  "2efa7067399a": "active projects",
  "2f4979324e03": "Condition",
  "2f8f376ad77b": "Pagtanggap",
  "309c693a5ffa": "Customer name",
  "30ad4167acea": "Remaining:",
  "3142b38e900f": "Mga Gastos sa Fleet",
  "31e1ca3152df": "Buildings & Infrastructure",
  "31fbb9d2e0d1": "pagination",
  "32cf4b682e2b": "Executive View",
  "33ce417454bf": "Naglo-load…",
  "33f0b19c138a": "· Variable/unit",
  "3430e769856a": "· Labor",
  "346b137aaeb4": "Lampas sa Takdang Petsa Service",
  "34a79d015463": "Yield (kg)",
  "34be468c005c": "In Use",
  "355bcc577d71": "Finished",
  "35683fd19bd3": "Walang purchase order",
  "35aafb9af03e": "Maghanap lot, product, or supplier...",
  "35cf82f9d2a9": "Revenue",
  "36155d48f460": "Kagamitan",
  "36d4b773518b": "Plot",
  "3703cd216881": "Health",
  "373a53a12353": "Contractors",
  "38eb50e0cbea": "AND A BETTER FUTURE.",
  "38ef04880312": "Hindi maaaring baguhin ang mga tala ng bukid",
  "38ff36471160": "Well, river, rain…",
  "3917cc63a2b1": "Fuel Type",
  "396c65e60e58": "Supplier *",
  "3a670a7af036": "Wala pang pond.",
  "3b158d60607f": "Idagdag sa Home Screen — gumagana offline sa bukid.",
  "3b4dfc971393": "Working",
  "3b906ae77c48": "— None —",
  "3c1a07ad42ed": "e.g. LOT-2026-001",
  "3c363836cf4e": "d",
  "3c45b957fdc8": "Pagbili Order",
  "3ca8f5487b17": "vehicles",
  "3d0ec3f6c93a": "Analytics ng Supplier",
  "3d5553209809": "Ngayon ·",
  "3dd7d56a8ed3": "Export PDF",
  "3deb74565196": "Type",
  "3f0631d97412": "Area (hectares)",
  "3f657f29e683": "Pumili ng bagong password",
  "4011820e918a": "e.g. Urea 46-0-0",
  "404c5194e7ac": "Target harvest",
  "4052cedd127f": "Supplier count",
  "40cd63f2ed77": "Photo Gallery URLs (one per line)",
  "412226715c56": "Clear filters",
  "4130f658233f": "Magdagdag ng Unit",
  "416a07cf4e79": "Paglalarawan*",
  "4186c93a90f9": "Buyer",
  "41fbe295b7ab": "Stage:",
  "4310ed540c1c": "Late",
  "4317a9f49f13": "On Break",
  "43365110276c": "Rain now",
  "439e231109dc": "Order Petsa",
  "43dc8532f7e5": "Halaga",
  "4496cd8c9d41": "Pumili plot…",
  "44d25b5d1b6d": "Items",
  "44f6af694554": "Quantity",
  "4629710df161": "Aktibo employees",
  "465aedef3c60": "Naglo-load ang forecast…",
  "4729f4827a28": "Itala ang Oras ng Makina",
  "4755bb542fc4": "Walang spare parts yet.",
  "48bc81639dbc": "Mga Pond",
  "48fe35a1d256": "Sales · Profit · Break-Even · Targets · Payroll ·",
  "4949c4c8f45c": "Kabuuan Value",
  "499bd9281e33": "Monthly Payroll",
  "4a245944efb6": "Export Excel",
  "4a3c315b5cb3": "Mga Tala ng Kalidad ng Tubig",
  "4a7c565d4c44": "Confirm password",
  "4b8e53dd3dae": "Walang monthly target set.",
  "4bab2d8fe13f": "More",
  "4bcd00d023b4": "Mga Tala / Work performed",
  "4be4414aa252": "Kabuuan Mga Pond",
  "4bf41b254218": "Walang receiving queue",
  "4c10f68d1ec6": "project(s) are",
  "4c25b4dd9300": "Track pond stocks and water-quality metrics (Tilapia · Bangus · Catfish · Shrimp).",
  "4c98c7c959cf": "Read-only na suporta sa pagpapasya",
  "4cb8d8545ed6": "Station",
  "4d4add04f200": "Comma-separated parts",
  "4da821676b2f": "Bumalik sa pag-sign in",
  "4dcd818cab26": "Direktoryo ng Supplier",
  "4e4a56efd2f0": "Maintenance Gastos",
  "4edef537bfac": "Odo:",
  "4efaca55bbdd": "Walang service records yet.",
  "4f3a4ea5fc7f": "hrs ·",
  "4f68eeac77e4": "Mga Proyekto, assets, contractors, budgets and repair schedules — all in one place.",
  "501e80194351": "Revenue (₱)",
  "5057c9400b5c": "Health guidance is decision support only, not a veterinary diagnosis. Serious, worsening, or uncertain cases require veterinarian review.",
  "50b61e0c8341": "Expiring Soon",
  "50f94286ba30": "Nakaraan",
  "51f98f12a890": "Service Interval (days)",
  "524d1b0e5963": "Receipt reference",
  "527d428ee46b": "Assigned Driver",
  "52b139c9d30c": "Halaga (",
  "5301648dcf6b": "I-edit",
  "535f9fd79916": "e.g. Deliver before 10 AM",
  "53a849c428ba": "Hours Alerts",
  "53e890d5f0ff": "Mga Proyekto",
  "55edd462872a": "Supplier",
  "55ef43bbccd7": "· Hours",
  "55f8ebc805e6": "Paglalarawan",
  "5612a12912ba": "Repair · Month",
  "5635a7fdb9c2": "d (",
  "56e3badc4e6c": "I-refresh",
  "57162c35dea4": "Pangalan*",
  "57328afd89ad": "Assign a customer, driver, and scheduled date.",
  "57a923cebb64": "Payment Tracking Snapshot",
  "57d6453a76e4": "Hindi wasto ang reset link na ito. Humiling ng bago.",
  "582c2c765413": "Plot name*",
  "58caebadd832": "Planted",
  "59ef31e37acc": "Reorder Level",
  "5a2a2aa092fe": "Walang fleet expenses yet.",
  "5a32ec8d373c": "Outstanding value",
  "5a61e634ec49": "PLAN",
  "5af2ae528662": "Itala ang Aktibidad",
  "5b62ea1bf903": "Mga Pond at Kalidad ng Tubig",
  "5bcce6c9362d": "Kabuuan Mga Sasakyan",
  "5bdc5634400e": "Receipt Upload",
  "5c0a29f837f1": "Hours:",
  "5c7f68126c6b": "21 default categories + your custom ones. Owner can add unlimited custom categories.",
  "5c9c59bd74d3": "Tanggalin ang plot",
  "5d08f9511d95": "Rows:",
  "5d597153857a": "Track a construction, expansion, or repair job with budget and progress.",
  "5e7c42bc25c3": "AI Katulong",
  "5e7dbabf8c70": "GROW",
  "5ee99df097d2": "Rating (1-5)",
  "5f60b1c2e605": "Repair",
  "5f8b47c8c9a9": "-day forecast",
  "6036f38949f0": "Health Score",
  "610c693d18b1": "Expenses (Month)",
  "616ec7943070": "Naglo-load ang purchasing...",
  "6197c35f640d": "Itala ang Fuel",
  "61b1942702f8": "Magdagdag ng your first plot",
  "61cc55aa0453": "Magdagdag ng",
  "61d2e70b54c2": "Traceability",
  "62a0ddfe7104": "Oil Change Due:",
  "62b4e20b30bd": "Yield (kg)*",
  "63a33115983f": "Magtanong tungkol sa awtorisadong tala ng bukid…",
  "64ae43e8fe76": "Gastos",
  "64f5d600a1cc": "Pond",
  "65004e4ff3fd": "overdue service",
  "6553548c02a1": "Natanggap orders will appear here.",
  "65adb9c296d2": "Humidity",
  "65c2337e5a7b": "Assigned Operators",
  "65f495119086": "to start.",
  "6723e47bb201": "reorder @",
  "674d8f64aa0b": "Battery Replacement:",
  "67f0a1936718": "Reading (hours)",
  "6923181702d9": "Spent:",
  "69a52c6de668": "Next:",
  "69bd4ef9fbd0": "View",
  "6b12d06ba166": "Operating",
  "6c19a4761d7e": "Listening…",
  "6ca74ddd7700": "low)",
  "6ccb60071be8": "Kategorya",
  "6d304f7b0a2f": "6-Month Trend",
  "6da13addb000": "Source",
  "6e0f112a6c87": ". Fill and score them there.",
  "6e3d52434a58": "Pagbili",
  "6e5ce570b4af": "breadcrumb",
  "6e9397b6dbba": "Monthly Sales Target",
  "6e979f426b67": "MB",
  "6eef6648406c": "None",
  "6f4789b025a1": "Open →",
  "6f6f0f6a0fb3": "m²",
  "6f9f011c5d36": "Longitude",
  "6fceba68eac8": "Mga Kahilingan sa Pagbili",
  "701c3a2750eb": "Log harvest",
  "70440046a3dc": "Mga Tala",
  "704aac3a9bc5": "Supplier records appear automatically from live inventory items and purchase orders.",
  "709a23220f2c": "Pangalan",
  "70f132fe13e6": "fields",
  "70f90c2aa98d": "Barangay or landmark",
  "71e7e5db4ac7": "Next Due Petsa",
  "747876156da0": "Pagbili Gastos",
  "74feb2cafbea": "Pagbili Petsa",
  "750134b65d1b": "Kabuuan Expenses",
  "753a22b2eb61": "Notifications",
  "7564829fea86": "Walang batches match. Magdagdag ng your first!",
  "7600ac5e38ed": "Service Due:",
  "7658feb298a0": "Assigned Operator",
  "76cadcf0cd78": "Farm records are summarized and minimized before provider use.",
  "77064d526523": "Phone",
  "77777ca55ede": "Wala pang kagamitan. I-click",
  "7790f856aec6": "Walang purchase history",
  "77dfd2135f4d": "Kanselahin",
  "788e8718ca16": "Contractor (optional)",
  "7a2c34cb789c": "Logistics",
  "7a4af421292d": "Bagong Plot",
  "7ab3015465a9": "Maghanap orders",
  "7aeba4cd15b1": "Badyet",
  "7c62a1424469": "Available",
  "7ceee3f3615a": "Provider",
  "7d8f801f3a78": "· Contractor:",
  "7da62f0b3f3f": "Assign later",
  "7e3275fc04cc": "Naglo-load ang mga batch ng produkto…",
  "7e4edd862a9d": "Harvest ETA",
  "7e5897fc1324": "Humingi ng suportang nakabatay sa datos ng bukid",
  "7f3cc23a2ff3": "Natanggap by (name)",
  "7ffef0952c80": "Next svc:",
  "80ea156e1b83": "Malusog",
  "81259aa4c0b6": "Filter, Belt, Bearing…",
  "81928ede6ce6": "Offline — gumagamit ng naka-cache na data",
  "81b7d2ea42df": "Petsa:",
  "83760b6974e1": "Magdagdag ng Piyesa",
  "83e2cb2108d1": "Walang fuel logs yet.",
  "842b7b5d7189": "Dates",
  "8430451c6c61": "Pick product",
  "84add5b29527": "Email",
  "84d296628caf": "Expected Petsa",
  "8544a4772583": "Profit",
  "85684fd76214": "employees marked today",
  "86761b63a7bd": "records",
  "869bd1fe0a00": "Mga Item na Mababang Stock",
  "877d5d5fa796": "Mga Natitirang Order",
  "88bc3fe3dadd": "Mga Ulat",
  "89c4cc389c22": "Pagbili orders created here will appear live.",
  "8a2783493a54": "Paparating Services",
  "8b8b0e4621e0": "Farm:",
  "8bf1ef5668b1": "Batch",
  "8c603960eb2f": "Walang species yet.",
  "8d007050838a": "Expiry Petsa",
  "8d437dbf95ab": "Expenses",
  "8d993b6d8820": "Pumunta sa nakaraang pahina",
  "8dce170de238": "Value",
  "8e53512a50fa": "Nakaraang slide",
  "8e9f1d6e54b9": "Not Started",
  "8eadc26886a5": "Mga Aktibong Proyekto",
  "8f7de73e0745": "Forms & Assessments",
  "8faf93a978fd": "CAPEX (Month)",
  "8fba6b663578": "Next Service",
  "8fe9db16be51": "Area:",
  "90c4ecded385": "Lot Number *",
  "910dc60963c7": "upcoming ·",
  "91262062ba6b": "Itala ang Kalidad ng Tubig",
  "917625318331": "units",
  "91cae9bcc20c": "Plate:",
  "92210c2cbd8f": "Supplier directory, purchase requests, purchase orders, receiving, purchase history, outstanding orders, and supplier analytics.",
  "9338d7d6f677": "FOR A STRONGER FARM",
  "936c86894f66": "I-install ang AJ's Farm",
  "937c13e9e29c": "Qty Natanggap *",
  "948bdc50fc2a": "Harvests",
  "9497c416e33c": "Log Service",
  "94c0384715e4": "· Fixed",
  "94db78855af5": "Clear pin",
  "94de303bbef8": "Maintenance",
  "952f375412e8": "Start",
  "9631af52c66f": "Delivery",
  "965fb2ddf63d": "Receive",
  "96662245e860": "Receipt URL",
  "96bb1ede828d": "POD",
  "97ca5f493a3d": "Draft, requested, approved, and ordered records are treated as live purchase requests using the existing purchase order backend.",
  "98061c6fa8e2": "Unit Gastos (₱)",
  "9a14702e37fb": "Wala pang plot.",
  "9b761dd12960": "Itala ang aktibidad ng pananim",
  "9b8dfdff736c": "BUILD",
  "9bb28c0dd307": "Sasakyan",
  "9bd9a1fc0241": "Mga Order that still need receiving will appear here.",
  "9c0048f2d882": "Log Hours",
  "9c3befe7e22c": "Mga Tala:",
  "9c7f732592c6": "Mga Plot",
  "9cb29e734a6c": "Lahat ng Statuses",
  "9cbf868b72bc": "Kabuuan Badyet",
  "9d579ae4103f": "Wala pang proyekto. Gumawa ng unang proyekto upang magsimulang mag-track.",
  "9d7ab1a55796": "Start Petsa",
  "9d94dbbd57c9": "Mga Supplier are derived from inventory items and purchase orders.",
  "9daa9201229d": "Gastos/Unit",
  "9f5cd8a2e880": "Subukan muli",
  "a124947cbd2d": "Low",
  "a17866573e05": "°C",
  "a225c8ebcac0": "Storage Lokasyon",
  "a229be11aa83": "e.g. Tool Shed, Barn A",
  "a278a03b221f": "— Shared pool —",
  "a2798d52947c": "Answers cite the AJ's Farm data categories used. Verify important operational, financial, and animal-health decisions with the responsible person.",
  "a2876d155984": "Primary Contractor",
  "a28f0cb43bd1": "Full delivery address",
  "a2a8b6d44e29": "Size (m²)",
  "a2f060b7363f": "Nakalimutan ang password?",
  "a371e0e8950b": "Requests in pipeline",
  "a38fbb777345": "Walang engine hour logs yet — add one to see trend.",
  "a3c686e711e4": "Kategorya",
  "a4cf971af7dc": "Susunod na slide",
  "a4ec6579de8a": "Paparating (date-based)",
  "a4f83557c6d5": "Plot*",
  "a52f821adb26": "Lot numbers, expiry dates, remaining quantity, and supplier per batch.",
  "a5905ef77ee7": "Use a safe example question",
  "a5b943a2e873": "Pond A",
  "a689a999a5e6": "Expired",
  "a69606c0dc7b": "Lokasyon label",
  "a733b809d2f1": "Aktibo",
  "a73c0b6b0574": "Pag-recover ng account",
  "a77a70c1dafa": "PLAN • BUILD • GROW",
  "a98926213d84": "Specialty",
  "a994e25516c0": "Walang report rows.",
  "aa9b6a90f790": "Progreso Update",
  "ab478f3efc84": "Map",
  "ab6e3f083b35": "· Next",
  "ac154da76d74": "over budget",
  "ac2dfb38024b": "Natanggap orders",
  "ad166ddcd6ce": "Bagong Contractor",
  "ae61226fd3ab": "Input / Product",
  "ae65324b857d": "Farm Operations",
  "aecc49c15355": "Grade",
  "aef614ca416f": "Invoice (optional)",
  "afdec0018746": "Track plots, activities, inputs and harvest yields.",
  "b077b9af222e": "Planted:",
  "b0854dcfffc4": "₱/kg",
  "b0946c471bef": "Pumili item",
  "b13bdb89caf8": "Gastos (₱)",
  "b1951f9838fc": "Gastos sa Fleet",
  "b1da58baf669": "Malusog Ranges",
  "b218a79feffb": "Magdagdag ng your first pond",
  "b25928c69902": "Kabuuan",
  "b3d95022b903": "Buildings, farm infrastructure, or other non-vehicle/non-machinery assets. (Mga Sasakyan → Fleet · Machinery/tools/pumps/generators → Machinery & Kagamitan.)",
  "b42abd2e5039": "Fuel Log",
  "b452abc00d55": "Mga Alerto sa Mababang Stock",
  "b568d47f2e24": "Input",
  "b5b7f6b7f66a": "Driver:",
  "b5d8da40f3ed": "Kabuuan Gastos",
  "b6531fded9a0": "Latest reading ·",
  "b6745abedefa": "Hindi available ang AI Assistant",
  "b69f996cc7ab": "· via Open-Meteo",
  "b766753f6fa4": "Isara ang prompt sa pag-install",
  "b7873d633d9b": "Any handover details",
  "b8f5ffa03eb9": "e.g. Coffee Pulper",
  "b9e04d3e4d00": "Online na muli — kumokonekta",
  "ba2fff4051e9": "overdue",
  "ba8f571e0f93": "Expiry",
  "bacca935870a": "Could not load Purchasing",
  "bae7d5be7082": "Katayuan",
  "bb56811cbaa0": "Fuel, registration, insurance, repairs, parts, tires, battery, oil, labor, and other operating costs.",
  "bbc7f274b22b": "Walang activities logged.",
  "bbfa773e5a63": "Isara",
  "bc4f986ecbca": "Mga Delivery",
  "bc981983e7f5": "Susunod",
  "bca6293c399c": "Markahan Bilang Natanggap",
  "bcc80a05869a": "Income (Month)",
  "bd55c18395bf": "Search by ID, plate, VIN, barcode...",
  "be3e12ed5902": "Qty Remaining",
  "be90668bac63": "Bagong Batch",
  "befd12a53600": "Target Petsa",
  "c010b1f6ac90": "plots have GPS coordinates. Set a plot's location by editing it and clicking on the map inside the dialog.",
  "c044647b0197": "- Unassigned -",
  "c088d79f1373": "Service Paparating",
  "c0d3c936adcd": "Spent",
  "c22d763a0516": "Kabuuan Batches",
  "c3290bda1143": "Mga Kategorya ng Kagamitan",
  "c3ab24576f62": "— Unassigned —",
  "c3b69e661eec": "Pumili…",
  "c4ebb2c814de": "asset(s) have",
  "c59c94e09696": "Bagong Order",
  "c5db3d91c4cb": "Crop",
  "c628afb091a6": "Maintenance · Month",
  "c83f9e9d5b4d": "Walang fleet unit na tumutugma sa kasalukuyang filter.",
  "c98cdd2ee123": "Walang kahilingan sa pagbili",
  "c9b5eabe92c4": "Service History",
  "c9f9a9698524": "Next Due @ Hours",
  "ca6d0e3aaa7d": "Stage",
  "cac7bbb6b67b": "Jane Doe",
  "cb0538e4ad77": "· overdue",
  "cb9e0f796b49": "Backend-calculated from live costs. Avg sale price",
  "cbce6e1d7dcf": "Fuel:",
  "cc1ebdd04e76": "Idle",
  "cc632b5e2fd2": "Remaining",
  "cccb682b71cf": "I-save Reading",
  "cce4cc8c49b7": "Mga Batch ng Produkto",
  "ccf67dadebe3": "Kabuuan Spent",
  "cd368978369a": "In Repair",
  "cd624d178121": "Paparating & Lampas sa Takdang Petsa Service",
  "ce99976c1fee": "Feels",
  "cec5fc32e25c": "Hours-based Alerts",
  "ced3905ec822": "Latitude",
  "cefb1df1fe3d": "Walang upcoming maintenance in the next 14 days.",
  "cf86f160deef": "AJ'S FARM MANAGEMENT SYSTEM",
  "cfb5a2036e18": "Reviewing authorized farm summaries…",
  "cfe7f49e435d": "Mag-iskedyul ng Delivery",
  "d1a17af19f53": "Not available",
  "d219c68101f5": "Lokasyon",
  "d2b8fb209caf": "Walk-in / Manual",
  "d2e9fc569cf0": "Makinarya at Kagamitan",
  "d4acbd528026": "Mga Pananim at Bukirin",
  "d5cf913dc0e0": "Capture buyer signature/name and a photo of the handover. Photo auto-uploads to your Google Drive Photos folder.",
  "d64f648a7f85": "I-save Pagbili Order",
  "d6941bad8202": "Wala pang delivery. I-iskedyul ang una!",
  "d6fa7b9a44a6": "e.g. Manong Reyes",
  "d6fdbd2508cb": "Expiring <7d",
  "d70f93df5e8f": "Address",
  "d850ee188c7c": "Bagong password",
  "d87f47b47e4d": "Dashboard",
  "d8d4986afb9d": "Seed variety",
  "d8e7170f94e7": "Kabuuan:",
  "d8f09bb951ba": "Tyre Replacement:",
  "da2be8a737a6": "Expected Harvest",
  "da33e1b7e0c4": "Konstruksyon",
  "da7be9accee6": "· reading",
  "daa495690e5b": "Warranty Expiry",
  "dbb3ca9ccf55": "Equipment Name / ID",
  "dbc0dcff747b": "Magdagdag ng a line-item cost against this project.",
  "dc3b2aa7a0e8": "Walang natitirang order",
  "dc6a02db7a5b": "Stocked Count",
  "dd3b86d1ef21": "Product",
  "dd44e0c7f248": "Auto-filled after upload",
  "dd8dbbd79e86": "Part Number",
  "ddab284f43b2": "Proof of Delivery ·",
  "de04fa0e29f9": "of",
  "de4fc5601204": "Konstruksyon at Maintenance",
  "de7b27e508f3": "AJ'S FARM",
  "de8dc3b5d39f": "Area (ha)",
  "e262a962cde2": "Record yield and revenue.",
  "e2767823d537": "North Field A",
  "e3970bebf8df": "Walang supplier records",
  "e40e6e6c4312": "Stocked count",
  "e45eb77d9c06": "Product *",
  "e51c55255be9": "Mga Tala",
  "e52a04d0c8ce": "Water source",
  "e58f7f889902": "Activities",
  "e623de0e43ee": "e.g. Rice (Palay)",
  "e6469a65672a": "ALL IN ONE COMMAND CENTER",
  "e7048b02e423": "Paid / received value",
  "e7278d717608": "Stocked date",
  "e7eccafdec41": "Liters",
  "e8171eb8b82a": "Break-Even Snapshot",
  "e8d05704af77": "Lot #",
  "e8f88ca7278e": "Kabuuan Kagamitan",
  "e95921ab1183": "Mga Template ng Inspeksyon ng Fleet",
  "e9b450d14bc2": "Done",
  "e9c45563358e": "Babala",
  "ea1787935b0b": "Secure na pag-reset",
  "ea3c24ad2473": "Utilization",
  "eb744bda0628": "Walang Expiry",
  "eb9a4bc1c0c1": "Petsa",
  "ec37183a6f52": "I-save Batch",
  "ecc3fb27c580": "Malusog Water-Quality Ranges (Warm-water Fish)",
  "eefa183380c8": "· Odo",
  "eefc13716b45": "One or more readings are critically outside healthy range. Consider immediate remediation (water change, aeration, etc.).",
  "ef46a8d2a13d": "GPS location — click on the map to drop a pin.",
  "efac482c1b4d": "Pond*",
  "efc007a393f6": "I-save",
  "f01f5d7ee661": "Walang water-quality logs yet.",
  "f0f704fd3636": "Gumamit ng hindi bababa sa 12 character na may malaking titik, maliit na titik, at numero.",
  "f12d9541e2f3": "e.g. Pig Pen 3",
  "f16f60e54c46": "Bagong Pond",
  "f187d5a1cc2f": "— Uncategorized —",
  "f1bf035da178": "Record a purchased or produced lot for traceability.",
  "f4286ad9a793": "Fuel Consumption & Gastos",
  "f4d631a14799": "VIN:",
  "f53d122b2016": "Magdagdag ng Gastos",
  "f5d794b98db8": "Schedule, dispatch, and confirm every farm delivery with photo POD.",
  "f64a2d812f7d": "Created today for the generations of tomorrow.",
  "f65d3258c00d": "Fresh",
  "f6741ee79071": "Maintenance / Repair",
  "f6b935ab3371": "Unit",
  "f6ce3b6fcfca": "Receipt",
  "f700fcdb40d3": "Insurance Due:",
  "f729524fe595": "Outstanding purchase orders are your receiving queue.",
  "f7d8733d94d5": "Supplier, note, date, status...",
  "f8ee57ec8645": "Outstanding",
  "f9316ab14683": "Pamamahala ng Fleet",
  "f9543f047f25": "Open in Forms",
  "f967a88e008c": "Wala pang supplier",
  "f9c30b15af01": "Break-Even Units",
  "f9eb0ad15ac8": "Fine-tune →",
  "f9fc27b9374a": "ha",
  "fa16fa0d667b": "Species*",
  "fb06270f7c21": "Page",
  "fd25edf497e5": "Harvest:",
  "fd57e65b2e31": "Bagong Proyekto",
  "fd6c3ebf7bef": "I-install",
  "fd7164f9ddd6": "Pumunta sa susunod na pahina",
  "fdd37fc793a8": "Order Value",
  "fe88fffd8a1e": "e.g. IR64",
  "fea8990fd0a9": "Lampas sa Takdang Petsa ·",
  "feb2bbaaed5b": "Missing:",
  "ff005838422b": "unmarked",
  "ff5b93665a3a": "Gastos / Unit ("
};
